import { Routes, Route } from "react-router-dom";

//components
import Header from "../../Header";
import Content from "../Content";
import Gallery from "../Gallery";
import Events from "../Events";
import Team from "../Team";
import Footer from "../../Footer";

//pages
import Resources from "../Resources";
import Resource from "../Resource";
import Event from "../Event";

export default function User() {
  return (
    <div className="min-vh-100 is-flex is-flex-direction-column is-align-content-center is-justify-content-space-between">
      <Header />
      <Routes>
        <Route path="/" element={<Content />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/resources/:id" element={<Resource />} />
        <Route path="/events" element={<Events />} />
        <Route path="/events/:id" element={<Event />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/team" element={<Team />} />
      </Routes>
      <Footer />
    </div>
  );
}
